import { FtueVideo, FtueVideoThumbnail } from '../../../../api/core'
import { EditableFtueChapter } from '../../../components/FtueChapterEditor/ftueChapterHelpers'

export const FTUE_VIDEO_TYPE = 'ftue'

/** Legacy's attach body, in its key order. It has no `type`: the backend stores `null` until the first save sets `ftue`. */
export type FtueVideoAttachBody = {
  gameId: string
  gameVersion: string
  vimeoId: string
  marketIso: string
  names: { en: string }
  gameVersionReleaseDate: number
  thumbnails: FtueVideoThumbnail[]
  chapters: []
}

export type FtueVideoUpdateBody = Omit<FtueVideo, 'chapters'> & { chapters: EditableFtueChapter[] }

export type FtueVideoFormValues = {
  names: { [lang: string]: string }
  marketIso: string
  gameVersion: string
  gameVersionReleaseDate: number
  thumbnails: FtueVideoThumbnail[]
  chapters: EditableFtueChapter[]
}

export type FtueGameVersion = {
  version: string
  versionReleaseDate: number
}

export type FtueMarketOption = {
  iso: string
  name: string
}
